import { render, staticRenderFns } from "./BarDiscountForm.vue?vue&type=template&id=d818a3de&scoped=true"
import script from "./BarDiscountForm.vue?vue&type=script&lang=js"
export * from "./BarDiscountForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d818a3de",
  null
  
)

export default component.exports